/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import MarketRedirectPromptCard from './MarketRedirectPromptCard';
import { guidancePendingInvitations } from 'src/shared/app/market/guidance/settings/guidanceSettings';
import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';
import { pendingBraindatesRoute } from 'src/shared/app/base/route/setting/routeSettings';
import { getMembershipGuidanceCount } from 'src/shared/domain/membership/util/membershipUtil';
import { getMembership } from 'src/shared/domain/membership/selector/membershipSelectors';

const mapStateToProps = (state: Object, ownProps: Object): Object => {
  const membership = getMembership(state);

  return {
    ...ownProps,
    guidanceLabel: guidancePendingInvitations,
    invitationCount: membership && getMembershipGuidanceCount(membership),
    route: getRoutePath(pendingBraindatesRoute, state),
  };
};

export default compose(connect(mapStateToProps))(MarketRedirectPromptCard);
